import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppCompanyResolverGuard } from './app-company-resolver.guard';
import { AuthAdminGuard } from './core/auth/guard/auth-admin.guard';

export const routes: Routes = [
  {
    path: ':companyToken/auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: ':companyToken',
    canActivate: [AuthAdminGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
